import { IAutoMapper } from "../../../../core/automapper/interfaces";

export const mapAuditPackageContext = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "AuditPackageContext")
    .forMember("firstName", o => o.FirstName || o.firstName || "")
    .forMember("lastName", o => o.LastName || o.lastName || "")
    .forMember("userID", o => o.UserID || o.userID || 0)
    .forMember("isEditable", o => o.IsEditable ?? o.isEditable ?? false)
    .forMember("isLoggedIn", o => o.IsLoggedIn ?? o.isLoggedIn ?? false);
};
